import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import MyBooksPage from './pages/MyBooksPage';
import RecommendedPage from './pages/RecommendedPage';
import ResetPasswordPage from './pages/ResetPasswordPage'; 
import ProfilePage from './pages/ProfilePage';
import OtherUserProfilePage from './pages/OtherUserProfilePage';
import Navbar from './components/Navbar';
import BookDetails from './pages/BookDetails';
import Footer from './components/Footer';
import './App.css';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = (email) => {
    console.log('Logged in as:', email);
    localStorage.setItem('userEmail', email);
    navigate('/my-books');
  };

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
      <Route path="/my-books" element={<MyBooksPage />} />
      <Route path="/recommended" element={<RecommendedPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} /> 
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/profile/:userId" element={<OtherUserProfilePage />} key={location.pathname} />
      <Route path="/favorite/:bookId" element={<BookDetails />} />
      <Route path="/recommended" element={<RecommendedPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />


      
    </Routes>
  );
}

export default App;
